export const WIDGET_API_V4_BASE_URL = import.meta.env.VITE_WIDGET_API_URL;
export const WIDGET_ASSET_URL = import.meta.env.VITE_WIDGET_ASSETS_URL;